(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-product-videos-block"] && !Shopify.designMode) return;
  try {
    (function () {
    var scrollLock = { count: 0, pad: '' };

    function lockScroll() {
      if (scrollLock.count++ > 0) return;
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      scrollLock.pad = document.body.style.paddingRight;
      document.documentElement.classList.add('pv-locked');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      if (sbw > 0) {
        document.body.style.paddingRight = 'calc(' + (scrollLock.pad || '0px') + ' + ' + sbw + 'px)';
      }
    }

    function unlockScroll() {
      if (scrollLock.count === 0) return;
      if (--scrollLock.count > 0) return;
      document.documentElement.classList.remove('pv-locked');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.style.paddingRight = scrollLock.pad;
    }

    function buildMedia(item) {
      var media = item.querySelector('[data-pv-media]');
      if (!media) return;
      var type = item.dataset.type;
      media.innerHTML = '';
      if (type === 'mp4') {
        var v = document.createElement('video');
        v.src = item.dataset.src;
        v.controls = true; v.autoplay = true; v.loop = true; v.playsInline = true;
        v.setAttribute('playsinline', '');
        media.appendChild(v);
        var p = v.play(); if (p && p.catch) { p.catch(function () {}); }
      } else if (type === 'youtube' || type === 'vimeo') {
        var f = document.createElement('iframe');
        f.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        f.setAttribute('allowfullscreen', ''); f.loading = 'lazy';
        if (type === 'youtube') {
          f.src = 'https://www.youtube.com/embed/' + item.dataset.vid + '?autoplay=1&rel=0&playsinline=1';
        } else {
          f.src = 'https://player.vimeo.com/video/' + item.dataset.vid + '?autoplay=1';
        }
        media.appendChild(f);
      }
    }

    function clearMedia(item) {
      var media = item.querySelector('[data-pv-media]');
      if (media) media.innerHTML = '';
    }

    function initPV(root) {
      if (!root || root.dataset.scPvInit) return;
      root.dataset.scPvInit = 'true';

      var track = root.querySelector('[data-pv-track]');
      var prevBtn = root.querySelector('[data-pv-scroll="prev"]');
      var nextBtn = root.querySelector('[data-pv-scroll="next"]');

      var modal = root.querySelector('[data-pv-modal]');
      if (modal) {
        var mid = modal.getAttribute('data-pv-modal');
        var stale = document.querySelector('body > [data-pv-modal="' + mid + '"]');
        if (stale && stale !== modal && stale.parentNode) stale.parentNode.removeChild(stale);
        if (modal.parentNode !== document.body) document.body.appendChild(modal);
      }

      var items = modal ? Array.prototype.slice.call(modal.querySelectorAll('.pv__modal-item')) : [];
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pv-card]'));
      var current = 0;
      var lastFocus = null;

      function scrollByCard(dir) {
        var card = track.querySelector('.pv__slide');
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
      }

      function updateNav() {
        if (!prevBtn || !nextBtn) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        var noOverflow = track.scrollWidth <= track.clientWidth + 2;
        prevBtn.disabled = noOverflow || track.scrollLeft <= 2;
        nextBtn.disabled = noOverflow || track.scrollLeft >= maxScroll;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
      if (track) {
        track.addEventListener('scroll', updateNav, { passive: true });
        window.addEventListener('resize', updateNav);
        updateNav();
      }

      function show(index) {
        items.forEach(function (it, i) {
          if (i === index) { it.hidden = false; buildMedia(it); }
          else { it.hidden = true; clearMedia(it); }
        });
        current = index;
      }
      function open(index) {
        if (!modal || modal.hidden === false) return;
        lastFocus = document.activeElement;
        modal.hidden = false;
        lockScroll();
        show(index);
        var cb = modal.querySelector('[data-pv-close]');
        if (cb) cb.focus();
        document.addEventListener('keydown', onKey);
      }
      function close() {
        if (!modal || modal.hidden) return;
        items.forEach(clearMedia);
        modal.hidden = true;
        unlockScroll();
        document.removeEventListener('keydown', onKey);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      function go(dir) {
        if (!items.length) return;
        show((current + dir + items.length) % items.length);
      }
      function onKey(e) {
        if (e.key === 'Escape') { close(); return; }
        if (e.key === 'ArrowLeft') { go(-1); return; }
        if (e.key === 'ArrowRight') { go(1); return; }
        if (e.key === 'Tab') {
          var f = modal.querySelectorAll('button, [href], video, iframe, [tabindex]:not([tabindex="-1"])');
          f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () { open(parseInt(card.dataset.index, 10) || 0); });
      });

      var closeBtn = modal ? modal.querySelector('[data-pv-close]') : null;
      var prevM = modal ? modal.querySelector('[data-pv-prev]') : null;
      var nextM = modal ? modal.querySelector('[data-pv-next]') : null;
      if (closeBtn) closeBtn.addEventListener('click', close);
      if (prevM) prevM.addEventListener('click', function () { go(-1); });
      if (nextM) nextM.addEventListener('click', function () { go(1); });

      // Swipe left/right on mobile to change video (same as the arrows)
      var mTrack = modal ? modal.querySelector('[data-pv-modal-track]') : null;
      if (mTrack && items.length > 1) {
        var sx = 0, sy = 0, st = 0, swiping = false;
        mTrack.addEventListener('touchstart', function (e) {
          swiping = false;
          if (e.touches.length !== 1) return;
          var t = e.touches[0];
          // Ignore touches on the bottom 56px of the video, where the native scrubber sits
          var media = e.target.closest ? e.target.closest('[data-pv-media]') : null;
          if (media && t.clientY > media.getBoundingClientRect().bottom - 56) return;
          sx = t.clientX; sy = t.clientY; st = Date.now(); swiping = true;
        }, { passive: true });
        mTrack.addEventListener('touchend', function (e) {
          if (!swiping) return;
          swiping = false;
          var t = e.changedTouches[0];
          var dx = t.clientX - sx, dy = t.clientY - sy;
          if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5 || Date.now() - st > 800) return;
          go(dx < 0 ? 1 : -1);
        }, { passive: true });
        mTrack.addEventListener('touchcancel', function () { swiping = false; }, { passive: true });
      }
      if (modal) {
        modal.addEventListener('click', function (e) {
          if (!e.target.closest || !e.target.closest('.pv__modal-inner')) close();
        });
      }

      if (root.dataset.autoplayPreview === 'true' && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              if (!v.src && v.dataset.src) v.src = v.dataset.src;
              var p = v.play(); if (p && p.catch) p.catch(function () {});
            } else { v.pause(); }
          });
        }, { rootMargin: '200px' });
        root.querySelectorAll('[data-pv-preview]').forEach(function (v) { io.observe(v); });
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-sc-pv]').forEach(initPV);
    }

    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
      document.addEventListener('shopify:section:unload', function () {
        Array.prototype.forEach.call(document.querySelectorAll('body > [data-pv-modal]'), function (m) {
          if (!document.querySelector('[data-sc-pv] [data-pv-modal="' + m.getAttribute('data-pv-modal') + '"]')) return;
        });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
